import React from 'react';
import { Skeleton, SkeletonCircle } from '../ui/Skeleton';

export default function SkeletonCRMDetail() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-pulse">
      {/* Back link */}
      <Skeleton className="h-4 w-20 mb-4" rounded="rounded" />

      {/* Header */}
      <div className="flex items-center gap-4 mb-8">
        <SkeletonCircle size="w-12 h-12" />
        <div>
          <Skeleton className="h-6 w-40 mb-2" rounded="rounded" />
          <Skeleton className="h-4 w-24" rounded="rounded" />
        </div>
      </div>

      {/* Two-column layout */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Left column - Activity */}
        <div className="lg:col-span-2">
          <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 p-6">
            <Skeleton className="h-5 w-24 mb-4" rounded="rounded" />
            <Skeleton className="h-20 w-full mb-4" rounded="rounded-lg" />
            <div className="space-y-4">
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="flex gap-3">
                  <SkeletonCircle size="w-8 h-8" />
                  <div className="flex-1">
                    <Skeleton className="h-4 w-3/4 mb-1" rounded="rounded" />
                    <Skeleton className="h-3 w-20" rounded="rounded" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right column - Details */}
        <div>
          <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 p-6">
            <Skeleton className="h-5 w-20 mb-4" rounded="rounded" />
            <div className="space-y-4">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i}>
                  <Skeleton className="h-3 w-16 mb-1.5" rounded="rounded" />
                  <Skeleton className="h-4 w-full" rounded="rounded" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
